import React, { useState } from "react";
import emailjs from "emailjs-com";

const FeedbackForm = () => {
  const [status, setStatus] = useState("");

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm(
      "service_h568g3a",
      "template_jknrrgh",
      e.target,
      "wGpHM0qlO_0uoahsG",
    ).then(() => {
      setStatus("Message sent successfully!");
      e.target.reset();
    }).catch(() => {
      setStatus("Failed to send. Please try again.");
    });
  };

  return (
    <form onSubmit={sendEmail} style={{ marginTop: "2rem" }}>
      <h2>💬 Share Your Feedback</h2>
      <p>Have an idea or found a bug? We'd love to hear from you.</p>

      <input type="text" name="name" placeholder="Your name" required style={inputStyle} />
      <input type="email" name="email" placeholder="Your email" required style={inputStyle} />
      <textarea name="message" placeholder="Your message" rows="5" required style={textareaStyle}></textarea>
      <button type="submit" style={buttonStyle}>Send Feedback</button>

      {status && <p style={{ marginTop: "1rem", color: "green" }}>{status}</p>}
    </form>
  );
};

const inputStyle = {
  display: "block",
  width: "100%",
  padding: "0.5rem",
  marginBottom: "1rem",
  fontSize: "1rem"
};

const textareaStyle = { ...inputStyle };

const buttonStyle = {
  padding: "0.7rem 1.5rem",
  background: "#007bff",
  color: "#fff",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer"
};

export default FeedbackForm;